export default function Formulas() {
  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Editor de Fórmulas</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Motor de lógica para cálculos, transformações de texto e condições dinâmicas.
        </p>
      </div>

      <div className="bg-surface rounded-2xl shadow-sm p-10 flex flex-col items-center justify-center text-center gap-3">
        <span className="material-symbols-outlined text-on-surface-variant text-3xl">function</span>
        <p className="text-on-surface-variant text-[11px] max-w-md">
          Nenhuma fórmula cadastrada. O motor de fórmulas entra na fase de impressão profissional.
        </p>
      </div>
    </div>
  );
}
